export default "__VITE_ASSET__BdcT8KZn__"